import {
  EApplicantType,
  ECreditApplicationStep,
  EDocumentPageStatus,
  EDocumentStatus,
  EDocumentType,
  EFinancingProgram,
  ERequiredFrom,
  getEApplicantTypeList,
  getECreditApplicationStepList,
  getEDocumentPageStatusList,
  getEDocumentStatusSelectableList,
  getEDocumentTypeList,
  getEFinancingProgramList,
  getERequiredFromList,
} from '@if/core/types'
import * as yup from '@if/core/yup'

export const DocumentRequiredSchema = yup.object({
  id: yup.string().nullable(),
  creditApplicationId: yup.string().required(),
  financingProgramId: yup.string().required(),
  typeId: yup.numberEnum<EDocumentType>(getEDocumentTypeList()).required(),
  note: yup.string().nullable(),
  applicantType: yup
    .mixed<EApplicantType>()
    .oneOf(getEApplicantTypeList())
    .nullable()
    .transform((_, val: string | null | undefined) => {
      if (val === '' || val === undefined) {
        return null
      }
      return val
    }),
  requiredBeforeStep: yup
    .mixed<ECreditApplicationStep>()
    .nullable()
    .transform((_, val: string | null | undefined) => {
      if (val === '' || val === undefined) {
        return null
      }
      return val
    })
    .oneOf(getECreditApplicationStepList()),

  subKey: yup.string().nullable(),
  createdByUserId: yup.string().nullable(),
  createdByUserFullname: yup.string().nullable(),
  updatedByUserId: yup.string().nullable(),
  updatedByUserFullname: yup.string().nullable(),
  updatedOn: yup.date().nullable(),
  createdOn: yup.date().nullable(),
  versionTag: yup.string(),
  labelSuffix: yup.string().nullable(),
  requiredFrom: yup.mixed<ERequiredFrom>().oneOf(getERequiredFromList()).required().default(ERequiredFrom.Customer),
})

export type DocumentRequired = yup.InferType<typeof DocumentRequiredSchema>

export const DocumentPageSchema = yup.object({
  id: yup.string().required(),
  creditApplicationId: yup.string().required(),
  documentId: yup.string(),
  status: yup.mixed<EDocumentPageStatus>().oneOf(getEDocumentPageStatusList()),
  thumbnailUrl: yup.string().default(''),
  pageNumber: yup.integer().required(),
  rotation: yup.integer().required().default(0),
})

export type DocumentPage = yup.InferType<typeof DocumentPageSchema>

export const DocumentSchema = yup.object({
  id: yup.string().nullable(),
  creditApplicationId: yup.string().required(),
  financingProgramId: yup.mixed<EFinancingProgram>().oneOf(getEFinancingProgramList()).required(),
  applicantType: yup.mixed<EApplicantType>().nullable().oneOf(getEApplicantTypeList()),
  typeId: yup.mixed<EDocumentType>().required('numberRequired'),
  receivedOn: yup.date().nullable(),
  isPrivate: yup.boolean().nullable(),
  status: yup.mixed<EDocumentStatus>().oneOf(getEDocumentStatusSelectableList()),
  note: yup.string().nullable(),
  refusalReason: yup.string().nullable(),
  fileName: yup.string(),
  pages: yup.array(DocumentPageSchema).default([]),
  subKey: yup.string().nullable(),
  createdByUserId: yup.string().nullable(),
  createdByUserFullname: yup.string().nullable(),
  updatedByUserId: yup.string().nullable(),
  updatedByUserFullname: yup.string().nullable(),
  updatedOn: yup.date().nullable(),
  createdOn: yup.date().nullable(),
  versionTag: yup.string(),
  sasTokenUrl: yup.string().nullable(),
  labelSuffix: yup.string().nullable(),
})

export type Document = yup.InferType<typeof DocumentSchema>
